import Alpine from 'alpinejs'
import { convertObjectNumbersToString } from '../helpers/convertObjectNumbersToString'
import { pushDataLayer } from '../helpers/pushDataLayer'
import { leaseTypes } from '../leaseTypes'
import { Endpoints } from '../site'
import { scrollToElement } from './scrollToElement'
import countries from '../countryCodes.json'

// Initial data, used to reset the form.
const initialFormData = () => ({
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  phone_country_code: '+45',
  company_cvr: '',
  company: '',
  body: '',
  property_type: null,
  with_storage: false,
  square_metre_min: null,
  square_metre_max: null,
  rooms_min: null,
  rooms_max: null,
  employees_min: null,
  employees_max: null,
  price_from: null,
  price_to: null,
  accept_term: false,
  recaptcha_token: '',
  cities: [],
  facilities: [],
  current_url: '',
})

document.addEventListener('alpine:init', () => {
  Alpine.data('searchAgent', (url: string) => ({
    formData: initialFormData(),
    errors: null,
    errorMessage: null,
    submitted: false,
    hasStorageOption: false,
    isOfficeCommunity: false,
    isLivingSpace: false,
    cities: [],
    lease_types: leaseTypes,
    // Facilities are hardcoded for now.
    facilitiesBusiness: ['Parkering', 'Kantine/bistro', 'Rengøring', 'Indretningsarkitekt'],
    facilitiesPrivat: ['Parkering', 'Altan', 'Elevator', 'Husdyr'],
    currentUrl: url,
    countries: countries,

    // Fetch all cities from the API.
    fetchCitites(leaseType?: string) {
      const leaseTypeString = leaseType ? `&lease_type=${leaseType}` : ''
      return fetch(
        `${import.meta.env.MIX_API_BASE as string}${Endpoints.cities}?is_searchagent=true&sortby=name&direction=asc${leaseTypeString}`
      )
        .then((response) => response.json())
        .then((data) => {
          return (this.cities = data.data), (this.formData.cities = [])
        })
    },

    submit() {
      const thisData = this

      this.isOfficeCommunity
        ? ((thisData.formData.square_metre_min = null),
          (thisData.formData.square_metre_max = null),
          (thisData.formData.rooms_min = null),
          (thisData.formData.rooms_max = null))
        : this.isLivingSpace
          ? ((thisData.formData.employees_min = null), (thisData.formData.employees_max = null))
          : ((thisData.formData.employees_min = null),
            (thisData.formData.employees_max = null),
            (thisData.formData.rooms_min = null),
            (thisData.formData.rooms_max = null))

      if (thisData.formData.current_url === '') {
        thisData.formData.current_url = thisData.currentUrl
      }

      // google reCaptcha script to get token
      window.grecaptcha.ready(function () {
        window.grecaptcha
          .execute(`${import.meta.env.MIX_RECAPTCHA_SITE_KEY as string}`, {
            action: 'contact_form',
          })
          .then(function (token) {
            // token to reCaptcha_token in formData.
            thisData.formData.recaptcha_token = token

            fetch(`${import.meta.env.MIX_API_BASE as string}${Endpoints.searchAgent}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify(convertObjectNumbersToString(thisData.formData)),
            })
              .then((response) => {
                if (response.ok) {
                  pushDataLayer({
                    event: 'search_agent_form',
                    mail: thisData.formData.email,
                    phone: thisData.formData.phone,
                    propertyinterest: thisData.formData.property_type,
                  })
                  thisData.submitted = true
                  thisData.errors = null
                  thisData.errorMessage = null
                  thisData.formData = initialFormData()
                  window.dispatchEvent(
                    new CustomEvent('notice', {
                      detail: {
                        type: 'success',
                        text: 'Mange tak for din tilmelding til vores søgeagent. Vi glæder os til at vende tilbage til dig med forslag til dine kommende rammer.',
                      },
                    })
                  )
                  setTimeout(() => {
                    scrollToElement({ id: 'formReceipt', block: 'center' })
                  }, 200)
                } else if (response.status === 422) {
                  thisData.submitted = false
                  response.json().then((data) => {
                    thisData.errors = data.errors
                    thisData.errorMessage = data.message
                  })
                } else {
                  thisData.submitted = false
                  response.json().then((data) => {
                    window.dispatchEvent(
                      new CustomEvent('notice', { detail: { type: 'error', text: data.message } })
                    )
                    thisData.errors = data.errors
                    thisData.errorMessage = data.message
                  })
                }
              })
              .catch(() => {
                window.dispatchEvent(
                  new CustomEvent('notice', {
                    detail: { type: 'error', text: 'Der skete en fejl' },
                  })
                )
              })
          })
      })
    },

    init() {
      // Conditional logic for fields.
      const typeWithStorage = ['Kontor', 'Butik', 'Showroom']

      // @ts-ignore
      this.$watch('formData.property_type', (value: string) => {
        typeWithStorage.includes(value)
          ? (this.hasStorageOption = true)
          : (this.hasStorageOption = false)

        this.formData.with_storage = false
        this.formData.facilities = []

        value === 'Kontorfællesskab'
          ? (this.isOfficeCommunity = true)
          : (this.isOfficeCommunity = false)

        value === 'Bolig' ? (this.isLivingSpace = true) : (this.isLivingSpace = false)

        const typeObject = leaseTypes.find((type) => type.label === value)
        if (typeObject) this.fetchCitites(typeObject.id)
      })
    },
  }))
})
